import { useEffect } from 'react';

import { H3, P2 } from '../../../styles/FontStyles';

import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../../app/hooks';
import { Button, Flexed } from '../../../styles/GlobalComponents';
import { colors } from '../../../styles/GlobalStyles';
import { Overlay } from '../Overlay';
import { getMyHubsUnicaPay } from '../Portfolio.actions';

import { UnicaPayItem } from './UnicaPayItem';

export const UnicaPaySummary = () => {
  const dispatch = useDispatch();

  const { unicapay } = useAppSelector((state) => state.portfolio);

  useEffect(() => {
    dispatch(getMyHubsUnicaPay());
  }, [dispatch]);

  useEffect(() => {}, [unicapay]);

  return (
    <>
      <Flexed mb='40' center between rowSM>
        <H3 mbSM='10' color={colors.primary900}>
          My unica pay Cards
        </H3>

        <Button negative disabled maxWidth='250px' maxWidthSM='100%'>
          ADD UNICA PAY CARD
        </Button>
      </Flexed>

      <div>
        {unicapay?.orders?.map((item: any, index: number) => (
          <UnicaPayItem key={index} item={item} />
        ))}
      </div>
      {unicapay?.orders?.length === 0 && (
        <P2 center color={colors.neutral500}>
          No data available
        </P2>
      )}

      <Overlay />
    </>
  );
};
